import { render, staticRenderFns } from "./moveDialog.vue?vue&type=template&id=21075206&"
import script from "./moveDialog.vue?vue&type=script&lang=js&"
export * from "./moveDialog.vue?vue&type=script&lang=js&"
import style0 from "./moveDialog.vue?vue&type=style&index=0&id=21075206&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports